(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("core-js/modules/es.array.iterator.js"), require("core-js/modules/es.object.to-string.js"), require("core-js/modules/es.set.js"), require("core-js/modules/es.string.iterator.js"), require("core-js/modules/esnext.set.add-all.js"), require("core-js/modules/esnext.set.delete-all.js"), require("core-js/modules/esnext.set.difference.js"), require("core-js/modules/esnext.set.every.js"), require("core-js/modules/esnext.set.filter.js"), require("core-js/modules/esnext.set.find.js"), require("core-js/modules/esnext.set.from.js"), require("core-js/modules/esnext.set.intersection.js"), require("core-js/modules/esnext.set.is-disjoint-from.js"), require("core-js/modules/esnext.set.is-subset-of.js"), require("core-js/modules/esnext.set.is-superset-of.js"), require("core-js/modules/esnext.set.join.js"), require("core-js/modules/esnext.set.map.js"), require("core-js/modules/esnext.set.of.js"), require("core-js/modules/esnext.set.reduce.js"), require("core-js/modules/esnext.set.some.js"), require("core-js/modules/esnext.set.symmetric-difference.js"), require("core-js/modules/esnext.set.union.js"), require("core-js/modules/web.dom-collections.iterator.js"), require("@splat/constant"), require("@splat/theme"), require("@splat/popover"), require("@splat/validator"), require("@splat/input"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"));
	else if(typeof define === 'function' && define.amd)
		define(["core-js/modules/es.array.iterator.js", "core-js/modules/es.object.to-string.js", "core-js/modules/es.set.js", "core-js/modules/es.string.iterator.js", "core-js/modules/esnext.set.add-all.js", "core-js/modules/esnext.set.delete-all.js", "core-js/modules/esnext.set.difference.js", "core-js/modules/esnext.set.every.js", "core-js/modules/esnext.set.filter.js", "core-js/modules/esnext.set.find.js", "core-js/modules/esnext.set.from.js", "core-js/modules/esnext.set.intersection.js", "core-js/modules/esnext.set.is-disjoint-from.js", "core-js/modules/esnext.set.is-subset-of.js", "core-js/modules/esnext.set.is-superset-of.js", "core-js/modules/esnext.set.join.js", "core-js/modules/esnext.set.map.js", "core-js/modules/esnext.set.of.js", "core-js/modules/esnext.set.reduce.js", "core-js/modules/esnext.set.some.js", "core-js/modules/esnext.set.symmetric-difference.js", "core-js/modules/esnext.set.union.js", "core-js/modules/web.dom-collections.iterator.js", , , , , , , , , , , "core-js/modules/esnext.global-this.js"], factory);
	else if(typeof exports === 'object')
		exports["tag-select"] = factory(require("core-js/modules/es.array.iterator.js"), require("core-js/modules/es.object.to-string.js"), require("core-js/modules/es.set.js"), require("core-js/modules/es.string.iterator.js"), require("core-js/modules/esnext.set.add-all.js"), require("core-js/modules/esnext.set.delete-all.js"), require("core-js/modules/esnext.set.difference.js"), require("core-js/modules/esnext.set.every.js"), require("core-js/modules/esnext.set.filter.js"), require("core-js/modules/esnext.set.find.js"), require("core-js/modules/esnext.set.from.js"), require("core-js/modules/esnext.set.intersection.js"), require("core-js/modules/esnext.set.is-disjoint-from.js"), require("core-js/modules/esnext.set.is-subset-of.js"), require("core-js/modules/esnext.set.is-superset-of.js"), require("core-js/modules/esnext.set.join.js"), require("core-js/modules/esnext.set.map.js"), require("core-js/modules/esnext.set.of.js"), require("core-js/modules/esnext.set.reduce.js"), require("core-js/modules/esnext.set.some.js"), require("core-js/modules/esnext.set.symmetric-difference.js"), require("core-js/modules/esnext.set.union.js"), require("core-js/modules/web.dom-collections.iterator.js"), require("@splat/constant"), require("@splat/theme"), require("@splat/popover"), require("@splat/validator"), require("@splat/input"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("core-js/modules/esnext.global-this.js"));
	else
		root["tag-select"] = factory(root["core-js/modules/es.array.iterator.js"], root["core-js/modules/es.object.to-string.js"], root["core-js/modules/es.set.js"], root["core-js/modules/es.string.iterator.js"], root["core-js/modules/esnext.set.add-all.js"], root["core-js/modules/esnext.set.delete-all.js"], root["core-js/modules/esnext.set.difference.js"], root["core-js/modules/esnext.set.every.js"], root["core-js/modules/esnext.set.filter.js"], root["core-js/modules/esnext.set.find.js"], root["core-js/modules/esnext.set.from.js"], root["core-js/modules/esnext.set.intersection.js"], root["core-js/modules/esnext.set.is-disjoint-from.js"], root["core-js/modules/esnext.set.is-subset-of.js"], root["core-js/modules/esnext.set.is-superset-of.js"], root["core-js/modules/esnext.set.join.js"], root["core-js/modules/esnext.set.map.js"], root["core-js/modules/esnext.set.of.js"], root["core-js/modules/esnext.set.reduce.js"], root["core-js/modules/esnext.set.some.js"], root["core-js/modules/esnext.set.symmetric-difference.js"], root["core-js/modules/esnext.set.union.js"], root["core-js/modules/web.dom-collections.iterator.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_core_js_modules_es_array_iterator_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_object_to_string_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_set_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_string_iterator_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_add_all_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_delete_all_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_difference_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_every_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_filter_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_find_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_from_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_intersection_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_disjoint_from_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_subset_of_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_superset_of_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_join_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_map_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_of_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_reduce_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_some_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_symmetric_difference_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_union_js__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_web_dom_collections_iterator_js__, __WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE__splat_popover__, __WEBPACK_EXTERNAL_MODULE__splat_validator__, __WEBPACK_EXTERNAL_MODULE__splat_input__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/input.tsx":
/*!***********************!*\
  !*** ./src/input.tsx ***!
  \***********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_15__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};










var TagInput = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(TagInput, _tsx$Component);

  var _super = _createSuper(TagInput);

  function TagInput() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, TagInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "tags", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "block", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "readonly", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "delimiter", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "deleter", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_formItemInstance", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "validateState", {
      type: _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.unknown
    });

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(TagInput, [{
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "onChange",
    value: function onChange(v) {}
  }, {
    key: "onDelimiter",
    value: function onDelimiter(v) {}
  }, {
    key: "onDelete",
    value: function onDelete(v, i) {}
  }, {
    key: "onEdit",
    value: function onEdit(v, i) {}
  }, {
    key: "onOptionsChange",
    value: function onOptionsChange() {
      if (this.formItemInstance) {
        this.validateState = this.formItemInstance.onChanged();
      }
    }
  }, {
    key: "formItemInstance",
    get: function get() {
      var _formItemInstance = this._formItemInstance;
      return _formItemInstance ? _formItemInstance() : null;
    }
  }, {
    key: "updateState",
    value: function updateState(v) {
      this.validateState = v;
    }
  }, {
    key: "handleInput",
    value: function handleInput(v) {
      this.onInput(v.target.value);

      if (this.formItemInstance) {
        this.validateState = this.formItemInstance.onChanged();
      }
    }
  }, {
    key: "handleChanged",
    value: function handleChanged(v) {
      this.handleInput(v);
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      var delimiter = this.delimiter,
          deleter = this.deleter,
          onDelimiter = this.onDelimiter,
          formItemInstance = this.formItemInstance,
          tags = this.tags;
      var value = e.target.value.trim();

      if (e.isComposing || e.keyCode === 229) {
        return;
      }

      if (value) {
        if (delimiter && delimiter.includes(e.key)) {
          onDelimiter(value);

          if (formItemInstance) {
            this.validateState = formItemInstance.onChanged();
          }

          (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)()(e);
        }
      } else {
        if (deleter && deleter.includes(e.key)) {
          this.onDelete(tags[tags.length - 1], tags.length - 1);

          if (formItemInstance) {
            this.validateState = formItemInstance.onChanged();
          }

          (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)()(e);
        }
      }
    }
  }, {
    key: "inputValidateStatusClassName",
    get: function get() {
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.failed:
          return _splat_input__WEBPACK_IMPORTED_MODULE_10__.InputStyles.inputFailedValidateStatusClassName;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.success:
          return null;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "renderValidateStatus",
    value: function renderValidateStatus() {
      var h = this.$createElement;
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.failed:
          return h("span", {
            "class": _splat_input__WEBPACK_IMPORTED_MODULE_10__.InputStyles.inputFailedValidateStatusMessageClassName
          }, [validateState.error]);

        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.success:
        case _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "containerValidateStateClassName",
    get: function get() {
      return this.validateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.failed ? _splat_input__WEBPACK_IMPORTED_MODULE_10__.InputStyles.inputContainerValidateStatusClassName : undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          tags = this.tags,
          renderValidateStatus = this.renderValidateStatus,
          readonly = this.readonly,
          block = this.block,
          disabled = this.disabled,
          placeholder = this.placeholder,
          onDelete = this.onDelete,
          onEdit = this.onEdit,
          handleInput = this.handleInput,
          handleChanged = this.handleChanged,
          handleKeydown = this.handleKeydown,
          inputValidateStatusClassName = this.inputValidateStatusClassName,
          containerValidateStateClassName = this.containerValidateStateClassName;
      return h("label", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(inputValidateStatusClassName, _style__WEBPACK_IMPORTED_MODULE_11__.tagInputWrapperClassName, block && _splat_input__WEBPACK_IMPORTED_MODULE_10__.InputStyles.inputBlockWrapperClassName, containerValidateStateClassName)
      }, [h("span", {
        "class": _splat_constant__WEBPACK_IMPORTED_MODULE_8__.displayContentsFullHeightClassName
      }, [tags.map(function (tag, i) {
        return h("span", {
          "class": _style__WEBPACK_IMPORTED_MODULE_11__.tagInputItemClassName,
          "key": i,
          "on": {
            "dblclick": function dblclick() {
              return onEdit(tag, i);
            }
          }
        }, [h("span", [tag]), h("i", {
          "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)('el-icon-close', _style__WEBPACK_IMPORTED_MODULE_11__.tagInputItemCloseClassName),
          "on": {
            "click": function click() {
              return onDelete(tag, i);
            }
          }
        })]);
      })]), h("input", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_11__.tagInputContainerClassName, disabled && _style__WEBPACK_IMPORTED_MODULE_11__.tagInputDisabledContainerClassName),
        "attrs": {
          "type": 'text',
          "disabled": disabled,
          "readonly": readonly,
          "placeholder": tags.length === 0 ? placeholder : undefined
        },
        "domProps": {
          "value": value
        },
        "on": {
          "input": handleInput,
          "change": handleChanged,
          "keydown": handleKeydown
        }
      }), renderValidateStatus()]);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.formItemInstance) {
        this.formItemInstance.setFormComponent(this);
        this.validateState = this.formItemInstance.onMounted();
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.formItemInstance) {
        this.formItemInstance.resetFormComponent(this);
      }
    }
  }]);

  return TagInput;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "tags", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "block", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TagInput.prototype, "readonly", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: function _default() {
    return ['Enter', ';', ',', ' '];
  }
})], TagInput.prototype, "delimiter", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: function _default() {
    return ['Backspace'];
  }
})], TagInput.prototype, "deleter", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('input')], TagInput.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('change')], TagInput.prototype, "onChange", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('delimiter')], TagInput.prototype, "onDelimiter", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('delete')], TagInput.prototype, "onDelete", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('edit')], TagInput.prototype, "onEdit", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Watch)('tags', {
  immediate: true
})], TagInput.prototype, "onOptionsChange", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Inject)({
  from: 'formItemInstance',
  default: null
})], TagInput.prototype, "_formItemInstance", void 0);

TagInput = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component], TagInput);
/* harmony default export */ __webpack_exports__["default"] = (TagInput);

/***/ }),

/***/ "./src/item.tsx":
/*!**********************!*\
  !*** ./src/item.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var TagInputMenuItem = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(TagInputMenuItem, _tsx$Component);

  var _super = _createSuper(TagInputMenuItem);

  function TagInputMenuItem() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, TagInputMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "checked", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "label", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(TagInputMenuItem, [{
    key: "onInput",
    value: function onInput(b, v) {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var checked = this.checked,
          value = this.value,
          label = this.label,
          onInput = this.onInput;
      onInput(!checked, {
        value: value,
        label: label
      });
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var value = this.value,
          label = this.label,
          checked = this.checked,
          disabled = this.disabled,
          handleClick = this.handleClick,
          theme = this.theme;
      return h("li", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_11__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.selectMenuItemClassName, checked && _style__WEBPACK_IMPORTED_MODULE_10__.selectMenuItemSelectedClassName, checked && theme ? _style__WEBPACK_IMPORTED_MODULE_10__.cloudSelectMenuItemSelectedClassName(theme) : null, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('tag-select', 'popover_item'), disabled && _style__WEBPACK_IMPORTED_MODULE_10__.selectMenuItemDisabledClassName),
        "on": {
          "click": handleClick
        }
      }, [this.$scopedSlots && this.$scopedSlots.default ? this.$scopedSlots.default({
        label: label,
        value: value
      }) : label]);
    }
  }]);

  return TagInputMenuItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], TagInputMenuItem.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], TagInputMenuItem.prototype, "checked", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], TagInputMenuItem.prototype, "label", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], TagInputMenuItem.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Emit)('input')], TagInputMenuItem.prototype, "onInput", null);

TagInputMenuItem = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], TagInputMenuItem);
/* harmony default export */ __webpack_exports__["default"] = (TagInputMenuItem);

/***/ }),

/***/ "./src/list.tsx":
/*!**********************!*\
  !*** ./src/list.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./select */ "./src/select.tsx");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_13__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var SelectMenu = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(SelectMenu, _tsx$Component);

  var _super = _createSuper(SelectMenu);

  function SelectMenu() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, SelectMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "styleType", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(SelectMenu, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      return h("ul", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_8__.selectMenuClassName, this.styleType === _select__WEBPACK_IMPORTED_MODULE_9__.TagSelectStyleType.Select && _style__WEBPACK_IMPORTED_MODULE_8__.selectStyleTypeUlClassName)
      }, [this.$slots.default]);
    }
  }]);

  return SelectMenu;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_11__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Prop)()], SelectMenu.prototype, "styleType", void 0);

SelectMenu = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_10__.Component], SelectMenu);
/* harmony default export */ __webpack_exports__["default"] = (SelectMenu);

/***/ }),

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    autocomplete: {
      empty: 'Empty',
      clean: 'Clear Selected'
    }
  },
  'zh-CHT': {
    autocomplete: {
      empty: "\u66AB\u7121\u6578\u64DA",
      clean: "\u6E05\u9664\u5DF2\u9078\u9805"
    }
  },
  'zh-CN': {
    autocomplete: {
      empty: "\u6682\u65E0\u6570\u636E",
      clean: "\u6E05\u9664\u5DF2\u9009\u9879"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/select.tsx":
/*!************************!*\
  !*** ./src/select.tsx ***!
  \************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TagSelectStyleType": function() { return /* binding */ TagSelectStyleType; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! core-js/modules/es.array.iterator.js */ "core-js/modules/es.array.iterator.js");
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! core-js/modules/es.object.to-string.js */ "core-js/modules/es.object.to-string.js");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! core-js/modules/es.set.js */ "core-js/modules/es.set.js");
/* harmony import */ var core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! core-js/modules/es.string.iterator.js */ "core-js/modules/es.string.iterator.js");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! core-js/modules/esnext.set.add-all.js */ "core-js/modules/esnext.set.add-all.js");
/* harmony import */ var core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_add_all_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! core-js/modules/esnext.set.delete-all.js */ "core-js/modules/esnext.set.delete-all.js");
/* harmony import */ var core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_delete_all_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! core-js/modules/esnext.set.difference.js */ "core-js/modules/esnext.set.difference.js");
/* harmony import */ var core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_difference_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! core-js/modules/esnext.set.every.js */ "core-js/modules/esnext.set.every.js");
/* harmony import */ var core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_every_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! core-js/modules/esnext.set.filter.js */ "core-js/modules/esnext.set.filter.js");
/* harmony import */ var core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_filter_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! core-js/modules/esnext.set.find.js */ "core-js/modules/esnext.set.find.js");
/* harmony import */ var core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_find_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_esnext_set_from_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! core-js/modules/esnext.set.from.js */ "core-js/modules/esnext.set.from.js");
/* harmony import */ var core_js_modules_esnext_set_from_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_from_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! core-js/modules/esnext.set.intersection.js */ "core-js/modules/esnext.set.intersection.js");
/* harmony import */ var core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_intersection_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! core-js/modules/esnext.set.is-disjoint-from.js */ "core-js/modules/esnext.set.is-disjoint-from.js");
/* harmony import */ var core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_disjoint_from_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! core-js/modules/esnext.set.is-subset-of.js */ "core-js/modules/esnext.set.is-subset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_subset_of_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! core-js/modules/esnext.set.is-superset-of.js */ "core-js/modules/esnext.set.is-superset-of.js");
/* harmony import */ var core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_is_superset_of_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! core-js/modules/esnext.set.join.js */ "core-js/modules/esnext.set.join.js");
/* harmony import */ var core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_join_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! core-js/modules/esnext.set.map.js */ "core-js/modules/esnext.set.map.js");
/* harmony import */ var core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_map_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_esnext_set_of_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! core-js/modules/esnext.set.of.js */ "core-js/modules/esnext.set.of.js");
/* harmony import */ var core_js_modules_esnext_set_of_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_of_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! core-js/modules/esnext.set.reduce.js */ "core-js/modules/esnext.set.reduce.js");
/* harmony import */ var core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_reduce_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! core-js/modules/esnext.set.some.js */ "core-js/modules/esnext.set.some.js");
/* harmony import */ var core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_some_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! core-js/modules/esnext.set.symmetric-difference.js */ "core-js/modules/esnext.set.symmetric-difference.js");
/* harmony import */ var core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_symmetric_difference_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! core-js/modules/esnext.set.union.js */ "core-js/modules/esnext.set.union.js");
/* harmony import */ var core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_set_union_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! core-js/modules/web.dom-collections.iterator.js */ "core-js/modules/web.dom-collections.iterator.js");
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var _splat_popover__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @splat/popover */ "@splat/popover");
/* harmony import */ var _splat_popover__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_splat_popover__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./input */ "./src/input.tsx");
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./item */ "./src/item.tsx");
/* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./list */ "./src/list.tsx");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_44__);










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

























var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_8__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};














var TagSelectStyleType;

(function (TagSelectStyleType) {
  TagSelectStyleType["Input"] = "Input";
  TagSelectStyleType["Select"] = "Select";
})(TagSelectStyleType || (TagSelectStyleType = {}));

var TagSelect = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__["default"])(TagSelect, _tsx$Component);

  var _super = _createSuper(TagSelect);

  function TagSelect() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__["default"])(this, TagSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "tagEditable", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "styleType", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "editable", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "filterOnly", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "loadBeforeSelect", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "dropdownInputPlaceholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "options", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "delimiter", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "tagValidator", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "dropMaxHeight", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "ThemeType", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "filterSelect", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "showPopover", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "loading", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "innerOptions", []);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "innerValue", '');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "innerValidateState", {
      type: _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "prevalueOptions", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "arrowStart", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "currentIndex", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "accDistance", 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "_formItemInstance", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "formItemInstanceMask", undefined);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "validateState", {
      type: _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_40__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_3__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__["default"])(TagSelect, [{
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "onAdd",
    value: function onAdd(v) {}
  }, {
    key: "formItemInstance",
    get: function get() {
      var _formItemInstance = this._formItemInstance;
      return _formItemInstance ? _formItemInstance() : null;
    }
  }, {
    key: "updateState",
    value: function updateState(v) {
      this.validateState = v;
    }
  }, {
    key: "onOptionsChange",
    value: function onOptionsChange(o, n) {
      this.updateInnerOptions();
    }
  }, {
    key: "onValueChange",
    value: function onValueChange() {
      this.updateInnerOptions();
    }
  }, {
    key: "updateCurrent",
    value: function updateCurrent() {
      var _this2 = this,
          _this$innerOptions;

      var filterOptions = this.value.filter(function (v) {
        return _this2.innerOptions.every(function (x) {
          return x.value != v.value;
        });
      });

      (_this$innerOptions = this.innerOptions).unshift.apply(_this$innerOptions, (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(filterOptions));
    }
  }, {
    key: "updateInnerOptions",
    value: function updateInnerOptions(once) {
      var _this3 = this;

      var value = this.value,
          innerValue = this.innerValue,
          options = this.options,
          updateValueLabel = this.updateValueLabel,
          updateCurrent = this.updateCurrent,
          styleType = this.styleType,
          showPopover = this.showPopover;

      if (Array.isArray(options)) {
        if (showPopover && styleType === TagSelectStyleType.Select && value.length) {
          updateCurrent();
        } else {
          this.innerOptions = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(options);
        }

        updateValueLabel();
      } else {
        var _this$prevalueOptions, _this$prevalueOptions2;

        if (((_this$prevalueOptions = this.prevalueOptions) === null || _this$prevalueOptions === void 0 ? void 0 : _this$prevalueOptions.value) === value && ((_this$prevalueOptions2 = this.prevalueOptions) === null || _this$prevalueOptions2 === void 0 ? void 0 : _this$prevalueOptions2.innerValue) === innerValue) {
          return;
        }

        this.loading = true;
        options(value, innerValue, once ? value.map(function (x) {
          return x.value;
        }) : undefined).then(function (op) {
          _this3.innerOptions = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(op);

          if (styleType === TagSelectStyleType.Select && value.length) {
            updateCurrent();
          }

          _this3.loading = false;
          updateValueLabel();
        });
        this.prevalueOptions = {
          value: value,
          innerValue: innerValue
        };
      }
    }
  }, {
    key: "updateValueLabel",
    value: function updateValueLabel() {
      var value = this.value,
          innerOptions = this.innerOptions,
          onInput = this.onInput;
      var updatedLabel = value.map(function (v) {
        return {
          value: v.value,
          label: ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.keyBy)(innerOptions, 'value')["".concat(v.value)] || v).label
        };
      });

      if (!(0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.arrayEqual)(value, updatedLabel, function (a, b) {
        return a.value === b.value;
      })) {
        onInput(updatedLabel);
      }
    }
  }, {
    key: "matchedOptions",
    get: function get() {
      var innerOptions = this.innerOptions,
          innerValue = this.innerValue,
          filterOnly = this.filterOnly,
          innerValidateState = this.innerValidateState;
      var matched = innerValue ? innerOptions.filter(function (x) {
        return x.label.indexOf(innerValue) !== -1;
      }) : innerOptions;

      if (!matched.some(function (x) {
        return x.label === innerValue;
      }) && innerValue.trim() && !filterOnly && innerValidateState.type !== _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed) {
        return (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.concat)([{
          label: innerValue,
          value: innerValue
        }], matched);
      }

      return matched;
    }
  }, {
    key: "handlePopoverChanged",
    value: function handlePopoverChanged(v) {
      var _this4 = this;

      this.showPopover = v;

      if (this.styleType === TagSelectStyleType.Select) {
        this.innerValue = '';
      }

      if (v && this.styleType === TagSelectStyleType.Select && this.value.length) {
        this.updateCurrent();
      }

      if (this.loadBeforeSelect && v) {
        this.updateInnerOptions();
      }

      if (!v) {
        this.updateInnerOptions();
      }

      if (v) {
        setTimeout(function () {
          var _this4$$refs$tag_inpu;

          ;
          (_this4$$refs$tag_inpu = _this4.$refs.tag_input) === null || _this4$$refs$tag_inpu === void 0 ? void 0 : _this4$$refs$tag_inpu.focus();
        }, 50);
      }
    }
  }, {
    key: "handleComplete",
    value: function handleComplete(b, v) {
      if (b) {
        this.onInput((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.concat)(this.value, [v]));

        if (this.styleType === TagSelectStyleType.Input) {
          this.innerValue = '';
        }
      } else {
        this.onInput(this.value.filter(function (i) {
          return i.value != v.value;
        }));
      }

      if (this.formItemInstance) {
        this.updateState(this.formItemInstance.onChanged());
      }
    }
  }, {
    key: "handleInnerValueInput",
    value: function handleInnerValueInput(v) {
      this.innerValue = v;
      this.handleCleanArrow();

      if (this.tagValidator) {
        this.innerValidateState = this.tagValidator('', v);
        var ipt = this.$refs.input;
        ipt === null || ipt === void 0 ? void 0 : ipt.updateState({
          type: _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown
        });
      }

      if (!this.showPopover) {
        this.showPopover = true;
      }

      this.updateInnerOptions();
    }
  }, {
    key: "handleInnerValueDelimiter",
    value: function handleInnerValueDelimiter(v, e) {
      var _this5 = this;

      if (e !== null && e !== void 0 && e.isComposing || (e === null || e === void 0 ? void 0 : e.keyCode) === 229) {
        return;
      }

      if (this.filterOnly && this.matchedOptions.length === 0) return;

      if (e) {
        (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.preventStop)()(e);
      }

      if (this.filterOnly && this.matchedOptions.length != 0) {
        var checked = this.matchedOptions[0];

        if (!this.value.some(function (v) {
          return v.value === checked.value;
        })) {
          this.onInput((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.concat)(this.value, [checked]));
        }

        this.innerValue = '';

        if (this.formItemInstance) {
          this.updateState(this.formItemInstance.onChanged());
        }

        return;
      }

      var ipt = this.$refs.input;
      ipt === null || ipt === void 0 ? void 0 : ipt.updateState(this.innerValidateState);
      if (this.innerValidateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed) return;
      this.innerValue = '';
      var index = this.innerOptions.findIndex(function (x) {
        return x.label === v;
      });

      if (index != -1) {
        if (!this.value.some(function (v) {
          return v.value === _this5.innerOptions[index].value;
        })) {
          this.onInput((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.concat)(this.value, [this.innerOptions[index]]));
        }
      } else {
        this.onAdd(v);
      }

      if (this.formItemInstance) {
        this.updateState(this.formItemInstance.onChanged());
      }
    }
  }, {
    key: "handleArrow",
    value: function handleArrow(direction) {
      var _this6 = this;

      var matchedOptions = this.matchedOptions;
      if (!matchedOptions.length) return;
      var menu = this.$refs.menu.$el; //start

      if (!this.arrowStart) {
        this.arrowStart = true;

        if (direction === 'ArrowUp') {
          this.currentIndex = matchedOptions.length - 1;
          this.$nextTick(function () {
            var item = _this6.$refs.menu.$el.querySelector("ul > .".concat(_style__WEBPACK_IMPORTED_MODULE_39__.arrowChooseItemClassName));

            var itemTop = item.offsetTop + item.clientHeight - menu.clientHeight;
            if (itemTop < 0) return;
            _this6.accDistance += itemTop;
            menu.scrollTo(0, _this6.accDistance);
          });
        } else {
          this.currentIndex = 0;
          menu.scrollTo(0, 0);
        }

        return;
      }

      if (direction === 'ArrowUp') {
        this.currentIndex = this.currentIndex === 0 ? matchedOptions.length - 1 : this.currentIndex - 1;
      }

      if (direction === 'ArrowDown') {
        this.currentIndex = this.currentIndex === matchedOptions.length - 1 ? 0 : this.currentIndex + 1;
      }

      this.$nextTick(function () {
        var menuHeight = menu.clientHeight;

        var item = _this6.$refs.menu.$el.querySelector("ul > .".concat(_style__WEBPACK_IMPORTED_MODULE_39__.arrowChooseItemClassName));

        var itemTop = item.getBoundingClientRect().top - menu.getBoundingClientRect().top;
        var itemHeight = item.clientHeight;
        var distance = menuHeight - (itemTop + itemHeight); //ArrowUp

        if (itemTop < 0) {
          _this6.accDistance += itemTop;
          menu.scrollTo(0, _this6.accDistance);
          return;
        } //ArrowDown


        if (distance < 0) {
          _this6.accDistance += Math.abs(distance);
          menu.scrollTo(0, _this6.accDistance);
        }
      });
    }
  }, {
    key: "handleArrowEnter",
    value: function handleArrowEnter() {
      var _this7 = this;

      var index = 0;
      var repeat = this.value.some(function (v, i) {
        index = i;
        return v.value === _this7.innerOptions[_this7.currentIndex].value;
      });

      if (!repeat) {
        this.onInput((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.concat)(this.value, [this.innerOptions[this.currentIndex]]));
        return;
      }

      this.value.splice(index, 1);
      this.onInput(this.value);
    }
  }, {
    key: "handleCleanArrow",
    value: function handleCleanArrow() {
      this.arrowStart = false;
      this.currentIndex = 0;
      this.accDistance = 0;
    }
  }, {
    key: "renderValidateStatus",
    value: function renderValidateStatus() {
      var h = this.$createElement;
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed:
          return h("span", {
            "class": _style__WEBPACK_IMPORTED_MODULE_39__.selectFailedValidateStatusMessageClassName
          }, [validateState.error]);

        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.success:
        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "selectValidateStatusClassName",
    get: function get() {
      var validateState = this.validateState;

      switch (validateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed:
          return _style__WEBPACK_IMPORTED_MODULE_39__.selectFailedValidateStatusClassName;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.success:
          return null;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "containerValidateStateClassName",
    get: function get() {
      return this.validateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed ? _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerValidateStatusClassName : undefined;
    }
  }, {
    key: "innerValueValidateStateClassName",
    get: function get() {
      return this.innerValidateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed ? _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerValidateStatusClassName : undefined;
    }
  }, {
    key: "innerValueValidateStatusClassName",
    get: function get() {
      var innerValidateState = this.innerValidateState;

      switch (innerValidateState.type) {
        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed:
          return _style__WEBPACK_IMPORTED_MODULE_39__.selectFailedValidateStatusClassName;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.success:
          return null;

        case _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.unknown:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var h = arguments[0];
      var value = this.value,
          innerValue = this.innerValue,
          innerOptions = this.innerOptions,
          delimiter = this.delimiter,
          matchedOptions = this.matchedOptions,
          disabled = this.disabled,
          tagEditable = this.tagEditable,
          editable = this.editable,
          loading = this.loading,
          styleType = this.styleType,
          placeholder = this.placeholder,
          dropMaxHeight = this.dropMaxHeight,
          showPopover = this.showPopover,
          handlePopoverChanged = this.handlePopoverChanged,
          handleComplete = this.handleComplete,
          handleInnerValueInput = this.handleInnerValueInput,
          handleInnerValueDelimiter = this.handleInnerValueDelimiter,
          renderValidateStatus = this.renderValidateStatus,
          containerValidateStateClassName = this.containerValidateStateClassName,
          selectValidateStatusClassName = this.selectValidateStatusClassName,
          dropdownInputPlaceholder = this.dropdownInputPlaceholder,
          innerValueValidateStateClassName = this.innerValueValidateStateClassName,
          innerValueValidateStatusClassName = this.innerValueValidateStatusClassName,
          innerValidateState = this.innerValidateState,
          handleArrow = this.handleArrow,
          handleArrowEnter = this.handleArrowEnter,
          arrowStart = this.arrowStart,
          currentIndex = this.currentIndex;
      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectContainerClassName, _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerInPrependAppendClassName, disabled && _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerDisabledClassName, containerValidateStateClassName, styleType === TagSelectStyleType.Select && _style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeWrapperClassName(disabled), styleType === TagSelectStyleType.Select && showPopover && _style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeHightlightClassName, styleType === TagSelectStyleType.Select && selectValidateStatusClassName, styleType === TagSelectStyleType.Select && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'select'), styleType === TagSelectStyleType.Select && showPopover && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'select_showPopover'))
      }, [h((_splat_popover__WEBPACK_IMPORTED_MODULE_34___default()), {
        "attrs": {
          "disabled": disabled,
          "value": showPopover,
          "dropMaxHeight": dropMaxHeight,
          "closeOnPopover": false
        },
        "on": {
          "input": handlePopoverChanged
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(styleType === TagSelectStyleType.Select ? _style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypePopoverFixClassName : _style__WEBPACK_IMPORTED_MODULE_39__.inputStyleTypePopoverFixClassName, _style__WEBPACK_IMPORTED_MODULE_39__.selectPopoverClassName)
      }, [h("template", {
        "slot": 'activity'
      }, [styleType !== TagSelectStyleType.Select ? h(_input__WEBPACK_IMPORTED_MODULE_36__["default"], {
        "ref": 'input',
        "attrs": {
          "value": innerValue,
          "delimiter": delimiter,
          "tags": (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(new Set(value.map(function (t) {
            return ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.keyBy)(_this8.innerOptions, 'value')["".concat(t.value)] || t).label;
          }))),
          "disabled": !editable,
          "placeholder": placeholder
        },
        "on": {
          "input": handleInnerValueInput,
          "delimiter": handleInnerValueDelimiter,
          "delete": function _delete(_, i) {
            return handleComplete(false, value[i]);
          },
          "edit": function edit(_, i) {
            if (tagEditable && !innerValue) {
              handleComplete(false, value[i]);
              _this8.innerValue = "".concat(value[i].label);
            }
          }
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(selectValidateStatusClassName, showPopover && _style__WEBPACK_IMPORTED_MODULE_39__.tagInputWrapperActiveClassName, !editable && _style__WEBPACK_IMPORTED_MODULE_39__.tagInputWrapperReadonlyClassName)
      }) : h("label", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeInputWrapperClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'label'), value.length ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'label_hasValue') : undefined)
      }, [this.$slots.placeholder || h("span", {
        "class": _style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypePlaceholderClassName
      }, [placeholder]), value.map(function (t) {
        return ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.keyBy)(_this8.innerOptions, 'value')["".concat(t.value)] || t).label;
      }).map(function (tag, i) {
        return h("span", {
          "class": 'tag'
        }, [tag]);
      }), value.length ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeCircularClassName, value.length / 10 >= 1 && _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerDoubleDigit, value.length / 100 >= 1 && _style__WEBPACK_IMPORTED_MODULE_39__.selectContainerThirdDigit)
      }, [h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeCircularScaleClassName
      }, [value.length])]) : null]), styleType === TagSelectStyleType.Select && value.length ? h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)('el-icon-close', _style__WEBPACK_IMPORTED_MODULE_39__.selectIconClassName),
        "on": {
          "click": function click(e) {
            _this8.onInput([]);

            _this8.showPopover = false;
            (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.preventStop)()(e);
          }
        }
      }) : h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)('iconfont icon-dropdown', _style__WEBPACK_IMPORTED_MODULE_39__.selectIconClassName, showPopover && _style__WEBPACK_IMPORTED_MODULE_39__.selectIconShowPopoverClassName)
      })]), styleType === TagSelectStyleType.Select ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeInputMenuSearchClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'search_wrapper'))
      }, [h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(innerValueValidateStateClassName, innerValueValidateStatusClassName)
      }, [h("input", {
        "ref": 'tag_input',
        "domProps": {
          "value": innerValue
        },
        "attrs": {
          "placeholder": dropdownInputPlaceholder
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeSearchInputClassName(this.theme), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'search')),
        "on": {
          "input": function input(e) {
            handleInnerValueInput(e.target.value);
          },
          "keydown": function keydown(e) {
            if (e.isComposing || e.keyCode === 229) {
              return;
            }

            if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
              e.preventDefault();
              handleArrow(e.key);
              return;
            }

            if (arrowStart && e.key === 'Enter') {
              e.preventDefault();
              handleArrowEnter();
              return;
            }

            var value = e.target.value.trim();

            if (value) {
              if (delimiter && delimiter.includes(e.key)) {
                handleInnerValueDelimiter(value, e);
              }
            }
          }
        }
      }), innerValidateState.type === _splat_validator__WEBPACK_IMPORTED_MODULE_35__.Status.failed ? h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectFailedValidateStatusMessageClassName, 'sl-id-filter__validate-message')
      }, [innerValidateState.error]) : null]), h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeInputIconClassName, innerValue ? 'el-icon-close' : 'el-icon-search'),
        "on": {
          "click": function click(e) {
            if (innerValue) {
              handleInnerValueInput('');
            }
          }
        }
      })]) : null, innerOptions && innerOptions.length || styleType !== TagSelectStyleType.Select ? h(_list__WEBPACK_IMPORTED_MODULE_38__["default"], {
        "ref": 'menu',
        "directives": [{
          name: "loading",
          value: loading
        }],
        "attrs": {
          "styleType": styleType
        }
      }, [matchedOptions.length ? matchedOptions.map(function (x, i) {
        return h(_item__WEBPACK_IMPORTED_MODULE_37__["default"], {
          "attrs": {
            "label": x.label,
            "value": x.value,
            "disabled": disabled || x.disabled,
            "checked": value.map(function (x) {
              return x.value;
            }).includes(x.value)
          },
          "on": {
            "input": handleComplete
          },
          "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(styleType === TagSelectStyleType.Input && _style__WEBPACK_IMPORTED_MODULE_39__.selectMenuItemHoverClassName, styleType === TagSelectStyleType.Select && _style__WEBPACK_IMPORTED_MODULE_39__.selectMenuItemFontClassName, arrowStart && i === currentIndex && _style__WEBPACK_IMPORTED_MODULE_39__.arrowChooseItemClassName)
        });
      }) : h(_item__WEBPACK_IMPORTED_MODULE_37__["default"], {
        "attrs": {
          "label": this.i18n.t.autocomplete.empty,
          "value": '',
          "disabled": true
        }
      })]) : null, innerOptions && innerOptions.length && styleType === TagSelectStyleType.Select ? h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_44__.classes)(_style__WEBPACK_IMPORTED_MODULE_39__.selectStyleTypeClearBarClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_32__.createSplatClassName)('tag-select', 'cleanAll')),
        "on": {
          "click": function click() {
            return _this8.onInput([]);
          }
        }
      }, [this.i18n.t.autocomplete.clean]) : null]), renderValidateStatus()]);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "created",
    value: function created() {
      this.updateInnerOptions(true);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }

      if (this.formItemInstance) {
        this.formItemInstance.setFormComponent(this);
        this.updateState(this.formItemInstance.onMounted());
      }

      document.addEventListener('mousemove', this.handleCleanArrow);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.formItemInstance) {
        this.formItemInstance.resetFormComponent(this);
      }

      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }

      document.removeEventListener('mousemove', this.handleCleanArrow);
    }
  }]);

  return TagSelect;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_42__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "tagEditable", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)({
  default: TagSelectStyleType.Input
})], TagSelect.prototype, "styleType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)({
  default: true
})], TagSelect.prototype, "editable", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)({
  default: false
})], TagSelect.prototype, "filterOnly", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)({
  default: false
})], TagSelect.prototype, "loadBeforeSelect", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "dropdownInputPlaceholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "options", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)({
  default: function _default() {
    return ['Enter', ';', ',', ' '];
  }
})], TagSelect.prototype, "delimiter", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "tagValidator", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "dropMaxHeight", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "ThemeType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Prop)()], TagSelect.prototype, "filterSelect", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Emit)('input')], TagSelect.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Emit)('add')], TagSelect.prototype, "onAdd", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Inject)({
  from: 'formItemInstance',
  default: null
})], TagSelect.prototype, "_formItemInstance", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Provide)('formItemInstance')], TagSelect.prototype, "formItemInstanceMask", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Watch)('options', {
  immediate: true
})], TagSelect.prototype, "onOptionsChange", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Watch)('value', {
  immediate: true
})], TagSelect.prototype, "onValueChange", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Inject)({
  from: 'i18nInjection',
  default: null
})], TagSelect.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Provide)('i18nInjection')], TagSelect.prototype, "i18nProvider", void 0);

TagSelect = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_41__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_33___default())]
})], TagSelect);
/* harmony default export */ __webpack_exports__["default"] = (TagSelect);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "selectContainerClassName": function() { return /* binding */ selectContainerClassName; },
/* harmony export */   "selectContainerInPrependAppendClassName": function() { return /* binding */ selectContainerInPrependAppendClassName; },
/* harmony export */   "selectContainerDisabledClassName": function() { return /* binding */ selectContainerDisabledClassName; },
/* harmony export */   "selectPopoverClassName": function() { return /* binding */ selectPopoverClassName; },
/* harmony export */   "inputStyleTypePopoverFixClassName": function() { return /* binding */ inputStyleTypePopoverFixClassName; },
/* harmony export */   "selectStyleTypePopoverFixClassName": function() { return /* binding */ selectStyleTypePopoverFixClassName; },
/* harmony export */   "selectValueClassName": function() { return /* binding */ selectValueClassName; },
/* harmony export */   "selectValueContentClassName": function() { return /* binding */ selectValueContentClassName; },
/* harmony export */   "selectValueInPrependAppendClassName": function() { return /* binding */ selectValueInPrependAppendClassName; },
/* harmony export */   "selectIconClassName": function() { return /* binding */ selectIconClassName; },
/* harmony export */   "selectIconShowPopoverClassName": function() { return /* binding */ selectIconShowPopoverClassName; },
/* harmony export */   "selectPlaceholderClassName": function() { return /* binding */ selectPlaceholderClassName; },
/* harmony export */   "selectHideInputClassName": function() { return /* binding */ selectHideInputClassName; },
/* harmony export */   "selectMenuClassName": function() { return /* binding */ selectMenuClassName; },
/* harmony export */   "selectMenuItemClassName": function() { return /* binding */ selectMenuItemClassName; },
/* harmony export */   "selectMenuItemDisabledClassName": function() { return /* binding */ selectMenuItemDisabledClassName; },
/* harmony export */   "selectMenuItemSelectedClassName": function() { return /* binding */ selectMenuItemSelectedClassName; },
/* harmony export */   "cloudSelectMenuItemSelectedClassName": function() { return /* binding */ cloudSelectMenuItemSelectedClassName; },
/* harmony export */   "selectFailedValidateStatusMessageClassName": function() { return /* binding */ selectFailedValidateStatusMessageClassName; },
/* harmony export */   "selectSuccessValidateStatusClassName": function() { return /* binding */ selectSuccessValidateStatusClassName; },
/* harmony export */   "selectContainerValidateStatusClassName": function() { return /* binding */ selectContainerValidateStatusClassName; },
/* harmony export */   "selectFailedValidateStatusClassName": function() { return /* binding */ selectFailedValidateStatusClassName; },
/* harmony export */   "tagInputWrapperClassName": function() { return /* binding */ tagInputWrapperClassName; },
/* harmony export */   "tagInputWrapperActiveClassName": function() { return /* binding */ tagInputWrapperActiveClassName; },
/* harmony export */   "tagInputContainerClassName": function() { return /* binding */ tagInputContainerClassName; },
/* harmony export */   "tagInputDisabledContainerClassName": function() { return /* binding */ tagInputDisabledContainerClassName; },
/* harmony export */   "tagInputItemClassName": function() { return /* binding */ tagInputItemClassName; },
/* harmony export */   "tagInputItemCloseClassName": function() { return /* binding */ tagInputItemCloseClassName; },
/* harmony export */   "tagInputWrapperReadonlyClassName": function() { return /* binding */ tagInputWrapperReadonlyClassName; },
/* harmony export */   "selectStyleTypeWrapperClassName": function() { return /* binding */ selectStyleTypeWrapperClassName; },
/* harmony export */   "selectStyleTypeHightlightClassName": function() { return /* binding */ selectStyleTypeHightlightClassName; },
/* harmony export */   "selectStyleTypeInputMenuSearchClassName": function() { return /* binding */ selectStyleTypeInputMenuSearchClassName; },
/* harmony export */   "inputBorderColors": function() { return /* binding */ inputBorderColors; },
/* harmony export */   "selectStyleTypeSearchInputClassName": function() { return /* binding */ selectStyleTypeSearchInputClassName; },
/* harmony export */   "selectStyleTypeClearBarClassName": function() { return /* binding */ selectStyleTypeClearBarClassName; },
/* harmony export */   "selectStyleTypePlaceholderClassName": function() { return /* binding */ selectStyleTypePlaceholderClassName; },
/* harmony export */   "selectStyleTypeInputWrapperClassName": function() { return /* binding */ selectStyleTypeInputWrapperClassName; },
/* harmony export */   "selectStyleTypeTagInputItemSpanClassName": function() { return /* binding */ selectStyleTypeTagInputItemSpanClassName; },
/* harmony export */   "selectStyleTypeCircularClassName": function() { return /* binding */ selectStyleTypeCircularClassName; },
/* harmony export */   "selectContainerDoubleDigit": function() { return /* binding */ selectContainerDoubleDigit; },
/* harmony export */   "selectContainerThirdDigit": function() { return /* binding */ selectContainerThirdDigit; },
/* harmony export */   "selectStyleTypeCircularScaleClassName": function() { return /* binding */ selectStyleTypeCircularScaleClassName; },
/* harmony export */   "selectStyleTypeInputIconClassName": function() { return /* binding */ selectStyleTypeInputIconClassName; },
/* harmony export */   "selectStyleTypeUlClassName": function() { return /* binding */ selectStyleTypeUlClassName; },
/* harmony export */   "selectMenuItemHoverClassName": function() { return /* binding */ selectMenuItemHoverClassName; },
/* harmony export */   "selectMenuItemFontClassName": function() { return /* binding */ selectMenuItemFontClassName; },
/* harmony export */   "arrowChooseItemClassName": function() { return /* binding */ arrowChooseItemClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_5__);


var _$nest2, _after, _$nest5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var selectContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.defaultSize)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(0), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)(0), {
  position: 'relative',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.fontSize),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.font.toString(),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.lineHeight),
  cursor: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('pointer')
});
var selectContainerInPrependAppendClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, ".".concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.prependClassName, " &, .").concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.appendClassName, " &"), _objectSpread(_objectSpread({}, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)(0, (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(-10))), {}, {
    width: 'auto',
    minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(64)
  }))
});
var selectContainerDisabledClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  opacity: 0.5,
  cursor: 'not-allowed'
});
var selectPopoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  position: 'static',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100)
});
var inputStyleTypePopoverFixClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: {
    '&>div:last-child': {
      width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100)
    }
  }
});
var selectStyleTypePopoverFixClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: {
    '&>div:last-child': {
      width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(224)
    }
  }
});
var selectValueClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.topBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.leftRightPadding)), csstips__WEBPACK_IMPORTED_MODULE_3__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_3__.center, csstips__WEBPACK_IMPORTED_MODULE_3__.betweenJustified, {
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.background.toString(),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.raduisSize),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.lineHeight),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.lineHeight)
});
var selectValueContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(csstips__WEBPACK_IMPORTED_MODULE_3__.flex, {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});
var selectValueInPrependAppendClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: (_$nest2 = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest2, ".".concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.prependClassName, " &, .").concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.appendClassName, " &"), {
    paddingTop: 0,
    paddingBottom: 0
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest2, ".".concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.prependClassName), {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest2, ".".concat(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.appendClassName), {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }), _$nest2)
});
var selectIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(csstips__WEBPACK_IMPORTED_MODULE_3__.content, _splat_constant__WEBPACK_IMPORTED_MODULE_1__.iconTransition, {
  position: 'absolute',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(6),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(8),
  fontWeight: 400,
  lineHeight: 1,
  verticalAlign: 'baseline',
  transform: (0,csx__WEBPACK_IMPORTED_MODULE_4__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_4__.deg)(0)),
  '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_4__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_4__.deg)(0))
});
var selectIconShowPopoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(selectIconClassName), {
    transform: (0,csx__WEBPACK_IMPORTED_MODULE_4__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_4__.deg)(180)),
    '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_4__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_4__.deg)(180))
  })
});
var selectPlaceholderClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.placeholder.toString()
});
var selectHideInputClassName = _splat_constant__WEBPACK_IMPORTED_MODULE_1__.hiddenInputClassName;
var selectMenuClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)(0), {
  padding: 0,
  width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100),
  position: 'relative',
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.menuBackground.toString(),
  maxHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(250),
  overflowY: 'auto'
});
var selectMenuItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4), (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12)), {
  position: 'relative',
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.lineHeight - 4),
  listStyle: 'none',
  display: 'block',
  wordWrap: 'break-word',
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.highlightBackground.toString()
    }
  }
});
var selectMenuItemDisabledClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  opacity: 0.5,
  background: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.menuBackground.toString()),
  color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.font.toString()),
  cursor: 'not-allowed'
});
var selectMenuItemSelectedClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.highlightFontColor.toString()),
  $nest: {
    '&::after': (_after = {
      position: 'absolute',
      right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(8),
      fontFamily: 'element-icons',
      content: "\"\\e6da\"",
      fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12),
      fontWeight: 700
    }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_after, '-webkit-font-smoothing', 'antialiased'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_after, '-moz-osx-font-smoothing', 'grayscale'), _after)
  }
});
var cloudSelectMenuItemSelectedClassName = function cloudSelectMenuItemSelectedClassName(theme) {
  var _SelectColors$themeHi;

  return (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
    color: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((_SelectColors$themeHi = _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.themeHighlight(theme)) === null || _SelectColors$themeHi === void 0 ? void 0 : _SelectColors$themeHi.toString())
  });
};
var selectFailedValidateStatusMessageClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  position: 'absolute',
  left: 0,
  top: (0,csx__WEBPACK_IMPORTED_MODULE_4__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100), " + ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(2))),
  color: '#C55252',
  lineHeight: 1
});
var selectSuccessValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  border: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.border)({
    color: '#35B053',
    style: 'solid',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1)
  })),
  paddingTop: 0,
  paddingBottom: 0
});
var selectContainerValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(csstips__WEBPACK_IMPORTED_MODULE_3__.layerParent, {
  marginBottom: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(10)
});
var selectFailedValidateStatusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  border: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)((0,csx__WEBPACK_IMPORTED_MODULE_4__.border)({
    color: '#C55252',
    style: 'solid',
    width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1)
  })),
  paddingTop: 0,
  paddingBottom: 0
});
var tagInputWrapperActive = {
  borderColor: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.focusBorder.toString()
};
var tagInputWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(csstips__WEBPACK_IMPORTED_MODULE_3__.inlineRoot, csstips__WEBPACK_IMPORTED_MODULE_3__.layerParent, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_input__WEBPACK_IMPORTED_MODULE_2__.InputSizes.defaultSize)), _objectSpread(_objectSpread({}, _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputStyles.inputWrapper), {}, {
  border: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputStyles.inputBorder,
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_input__WEBPACK_IMPORTED_MODULE_2__.InputSizes.raduisSize),
  minHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(22),
  $nest: {
    '&:hover': {
      borderColor: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.hoverBorder.toString()
    },
    '&:focus-within, &:active': tagInputWrapperActive,
    '& input::placeholder': {
      color: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.placeholder.toString()
    }
  },
  flexWrap: 'wrap'
}));
var tagInputWrapperActiveClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(tagInputWrapperClassName), tagInputWrapperActive)
});
var tagInputContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(csstips__WEBPACK_IMPORTED_MODULE_3__.flexRoot, (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(0, (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(10)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)(0), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)('auto'), _objectSpread(_objectSpread({}, _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputStyles.inputContainer), {}, {
  border: 'none',
  background: 'none',
  flexGrow: 1
}));
var tagInputDisabledContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.width)(0), {
  flexGrow: 0,
  flexShrink: 1
});
var tagInputItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_3__.height)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(18)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.padding)(0, (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4)), (0,csstips__WEBPACK_IMPORTED_MODULE_3__.margin)((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(2), (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4)), {
  display: 'inline-block',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonSizes.fontSize),
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(18),
  backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString(),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString(),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4),
  maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(80),
  $nest: {
    '&>span': {
      maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.calc)("".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100), " - ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(20))),
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
    }
  }
});
var tagInputItemCloseClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(8),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12),
  cursor: 'pointer',
  verticalAlign: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('super')
});
var tagInputWrapperReadonlyClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: (_$nest5 = {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest5, "&.".concat(tagInputWrapperClassName), {
    backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString(),
    borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString()
  }), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_$nest5, "&.".concat(tagInputWrapperClassName, " .").concat(tagInputItemClassName), {
    backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.white.toString()
  }), _$nest5)
});
var selectStyleTypeHightlight = {
  backgroundColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.fade(0.8).toString()
};
var selectStyleTypeWrapperClassName = function selectStyleTypeWrapperClassName(disabled) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
    maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(232),
    minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(105),
    height: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(24),
    width: 'auto',
    backgroundColor: '#F5F5F5',
    borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4),
    $nest: {
      '& label': {
        border: 'none'
      },
      '&:hover': disabled ? undefined : selectStyleTypeHightlight
    },
    cursor: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('pointer')
  });
};
var selectStyleTypeHightlightClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)(selectStyleTypeHightlight);
var selectStyleTypeInputMenuSearchClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  position: 'relative',
  padding: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(3), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(10), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4)),
  borderBottom: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1), " solid #F5F5F5"),
  cursor: 'default'
});
var inputBorderColors = function inputBorderColors(theme) {
  return {
    '&:hover': {
      borderColor: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.hoverBorder.toString()
    },
    '&:focus': {
      borderColor: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.themeFocusBorder(theme).toString()
    },
    '&::placeholder': {
      color: _splat_input__WEBPACK_IMPORTED_MODULE_2__.InputColors.placeholder.toString()
    }
  };
};
var selectStyleTypeSearchInputClassName = function selectStyleTypeSearchInputClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
    width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(204),
    height: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(24),
    padding: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(24), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12)),
    border: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1), " solid #E9E9E9"),
    borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4),
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12),
    outline: 'none',
    $nest: inputBorderColors(theme)
  });
};
var selectStyleTypeClearBarClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  borderTop: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(1), " solid #F5F5F5"),
  color: '#0B71BB',
  padding: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(2), " ").concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12)),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectSizes.lineHeight),
  cursor: 'pointer'
});
var selectStyleTypePlaceholderClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(2),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString()
});
var selectStyleTypeInputWrapperClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  width: 'auto',
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(105 - 47),
  maxWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(224 - 47),
  paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(10),
  marginRight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(47),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(24),
  display: 'inline-block',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  cursor: (0,csx__WEBPACK_IMPORTED_MODULE_4__.important)('pointer'),
  boxSizing: 'border-box',
  $nest: {
    'label&>span.tag + span.tag:before': {
      content: '"、"'
    },
    'label&>span.tag': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
    }
  }
});
var selectStyleTypeTagInputItemSpanClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  marginLeft: 0,
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(4),
  paddingLeft: 0,
  paddingRight: 0,
  marginRight: 0,
  $nest: {
    '&>span': {
      maxWidth: "".concat((0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(120))
    }
  }
});
var selectStyleTypeCircularClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(12),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(13),
  marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(5),
  position: 'absolute',
  right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(26),
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#FFFFFF',
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(2),
  backgroundColor: '#BFBFBF'
});
var selectContainerDoubleDigit = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(18),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(22)
});
var selectContainerThirdDigit = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(23),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(20)
});
var selectStyleTypeCircularScaleClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(100),
  transform: 'scale(0.8)',
  textAlign: 'center'
});
var selectStyleTypeInputIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  position: 'absolute',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(50),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(20),
  transform: (0,csx__WEBPACK_IMPORTED_MODULE_4__.translateY)((0,csx__WEBPACK_IMPORTED_MODULE_4__.percent)(-50)),
  fontWeight: 900,
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.placeholderText.toString(),
  cursor: 'pointer',
  $nest: {
    '&.el-icon-search': {
      cursor: 'default'
    }
  }
});
var selectStyleTypeUlClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  maxHeight: (0,csx__WEBPACK_IMPORTED_MODULE_4__.px)(205),
  overflowY: 'auto'
});
var selectMenuItemHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: {
    '&:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
    }
  }
});
var selectMenuItemFontClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
});
var arrowChooseItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.SelectColors.highlightBackground.toString()
});

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/es.array.iterator.js":
/*!*******************************************************!*\
  !*** external "core-js/modules/es.array.iterator.js" ***!
  \*******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_array_iterator_js__;

/***/ }),

/***/ "core-js/modules/es.object.to-string.js":
/*!*********************************************************!*\
  !*** external "core-js/modules/es.object.to-string.js" ***!
  \*********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_object_to_string_js__;

/***/ }),

/***/ "core-js/modules/es.set.js":
/*!********************************************!*\
  !*** external "core-js/modules/es.set.js" ***!
  \********************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_set_js__;

/***/ }),

/***/ "core-js/modules/es.string.iterator.js":
/*!********************************************************!*\
  !*** external "core-js/modules/es.string.iterator.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_es_string_iterator_js__;

/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.add-all.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.set.add-all.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_add_all_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.delete-all.js":
/*!***********************************************************!*\
  !*** external "core-js/modules/esnext.set.delete-all.js" ***!
  \***********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_delete_all_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.difference.js":
/*!***********************************************************!*\
  !*** external "core-js/modules/esnext.set.difference.js" ***!
  \***********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_difference_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.every.js":
/*!******************************************************!*\
  !*** external "core-js/modules/esnext.set.every.js" ***!
  \******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_every_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.filter.js":
/*!*******************************************************!*\
  !*** external "core-js/modules/esnext.set.filter.js" ***!
  \*******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_filter_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.find.js":
/*!*****************************************************!*\
  !*** external "core-js/modules/esnext.set.find.js" ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_find_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.from.js":
/*!*****************************************************!*\
  !*** external "core-js/modules/esnext.set.from.js" ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_from_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.intersection.js":
/*!*************************************************************!*\
  !*** external "core-js/modules/esnext.set.intersection.js" ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_intersection_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.is-disjoint-from.js":
/*!*****************************************************************!*\
  !*** external "core-js/modules/esnext.set.is-disjoint-from.js" ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_disjoint_from_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.is-subset-of.js":
/*!*************************************************************!*\
  !*** external "core-js/modules/esnext.set.is-subset-of.js" ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_subset_of_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.is-superset-of.js":
/*!***************************************************************!*\
  !*** external "core-js/modules/esnext.set.is-superset-of.js" ***!
  \***************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_is_superset_of_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.join.js":
/*!*****************************************************!*\
  !*** external "core-js/modules/esnext.set.join.js" ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_join_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.map.js":
/*!****************************************************!*\
  !*** external "core-js/modules/esnext.set.map.js" ***!
  \****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_map_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.of.js":
/*!***************************************************!*\
  !*** external "core-js/modules/esnext.set.of.js" ***!
  \***************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_of_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.reduce.js":
/*!*******************************************************!*\
  !*** external "core-js/modules/esnext.set.reduce.js" ***!
  \*******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_reduce_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.some.js":
/*!*****************************************************!*\
  !*** external "core-js/modules/esnext.set.some.js" ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_some_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.symmetric-difference.js":
/*!*********************************************************************!*\
  !*** external "core-js/modules/esnext.set.symmetric-difference.js" ***!
  \*********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_symmetric_difference_js__;

/***/ }),

/***/ "core-js/modules/esnext.set.union.js":
/*!******************************************************!*\
  !*** external "core-js/modules/esnext.set.union.js" ***!
  \******************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_set_union_js__;

/***/ }),

/***/ "core-js/modules/web.dom-collections.iterator.js":
/*!******************************************************************!*\
  !*** external "core-js/modules/web.dom-collections.iterator.js" ***!
  \******************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_web_dom_collections_iterator_js__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/input":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/input","commonjs2":"@splat/input"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_input__;

/***/ }),

/***/ "@splat/popover":
/*!***************************************************************************!*\
  !*** external {"commonjs":"@splat/popover","commonjs2":"@splat/popover"} ***!
  \***************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_popover__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "@splat/validator":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/validator","commonjs2":"@splat/validator"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_validator__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
/*!*****************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \*****************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js":
/*!******************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js ***!
  \******************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithoutHoles; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArray.js":
/*!****************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArray.js ***!
  \****************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js":
/*!******************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js ***!
  \******************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableSpread; }
/* harmony export */ });
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js":
/*!******************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js ***!
  \******************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toConsumableArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithoutHoles.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js");
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/iterableToArray.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableSpread.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js");




function _toConsumableArray(arr) {
  return (0,_arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__["default"])(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(arr) || (0,_nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
/*!***************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \***************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o, minLen);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TagInput": function() { return /* reexport safe */ _input__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   "TagSelectStyleType": function() { return /* reexport safe */ _select__WEBPACK_IMPORTED_MODULE_0__.TagSelectStyleType; }
/* harmony export */ });
/* harmony import */ var _select__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./select */ "./src/select.tsx");
/* harmony import */ var _input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./input */ "./src/input.tsx");


/* harmony default export */ __webpack_exports__["default"] = (_select__WEBPACK_IMPORTED_MODULE_0__["default"]);

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map